/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();

const headerNav = document.querySelector('#NavStandard');
const headerInnerContainer = document.querySelector('.header_inner_container');
if(window.innerWidth > 1022 && window.innerWidth < 1315){
  if(headerNav){headerNav.classList.add('custom_header_nav');}
  if(headerInnerContainer){headerInnerContainer.classList.add('custom_header_inner_container');}
}else{
  if(headerNav){headerNav.classList.remove('custom_header_nav');}
  if(headerInnerContainer){headerInnerContainer.classList.remove('custom_header_inner_container');}
}
window.addEventListener('resize',()=>{
  if(window.innerWidth > 1022 && window.innerWidth < 1315){
    if(headerNav){headerNav.classList.add('custom_header_nav');}
    if(headerInnerContainer){headerInnerContainer.classList.add('custom_header_inner_container');}
  }else{
    if(headerNav){headerNav.classList.remove('custom_header_nav');}
    if(headerInnerContainer){headerInnerContainer.classList.remove('custom_header_inner_container');}
  }
});

document.addEventListener('theme:cart:update', (event) => {
  console.log('Cart updated:', event.detail);
}, { bubbles: true });

function upgradeSubscription(event){
  console.log(event);
  const target = event.currentTarget;
  const oneTimeUpgrade = document.querySelector('.one-time-upgrade-btn');
  if(oneTimeUpgrade){
      const QuantityValue = document.querySelector('.lineItem_quantity').getAttribute('data-lineitem-quantity');
      const QuantityVariantID = document.querySelector('.lineItem_id').getAttribute('data-lineitem-id');
      const SellingplanID = document.querySelector('.selling_id').getAttribute('data-selling-id');
      const IntQuantityValue = parseInt(QuantityValue);
      
      let updates = {
        'id': QuantityVariantID,
        'quantity': IntQuantityValue,
        'selling_plan': SellingplanID,
      };
    
      // console.log(updates);
      
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updates)
      })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        const event = new CustomEvent('theme:cart:update', {
          bubbles: true,
          detail: {
            id: QuantityVariantID,
            quantity: IntQuantityValue,
          },
        });
        target.closest("[data-cart-item]").dispatchEvent(event);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }
}

document.addEventListener("DOMContentLoaded", (event) => {

  // customer service Accordion Desktop
  function CustomerServiceAcc(){    
    if(window.innerWidth > 767){
      const TabItems = document.querySelectorAll('.tabitem');
      const tabsDataShow = document.querySelectorAll('.tabsdata-show');
      if(TabItems.length > 0){
        TabItems.forEach(tab=>{
          if(tab){
            tab.addEventListener('click',()=>{
              const data_item = tab.getAttribute('data-tab');
              if(tabsDataShow.length > 0){
                tabsDataShow.forEach(tabdata=>{
                  const data_content = tabdata.getAttribute('data-container');
                  if(data_content == data_item){              
                    tabdata.style.display = "block";
                  } else{
                    tabdata.style.display = "none";
                  }
                });
              }
            })
          }
        })
      }
      // tabsDataShow.forEach(tabdata=>{
      //   tabdata.style.display = "none";
      // });
      // tabsDataShow[0].style.display = "block";
    }
  }
  CustomerServiceAcc();
  window.addEventListener('resize',()=>{
    CustomerServiceAcc();
  })

  // customer service Accordion Mobile
  function ServiceDropdown() {
    if(window.innerWidth < 768){
      const selectElement = document.querySelector('#service-titles');
      const AllElementsDescriptions = document.querySelectorAll('.accordion-item-description-wrapper .accordion-item-description');
      if (selectElement) {
        selectElement.addEventListener('change', (evt) => {
          if(evt){          
            const selectedOption = evt.target.options[evt.target.selectedIndex];
            const OptionAttr = selectedOption.getAttribute('service-value');
            if(AllElementsDescriptions.length > 0){
              AllElementsDescriptions.forEach(EleDes=>{
                const EleDesAttr = EleDes.getAttribute('data-target-value');
                if(!EleDes.classList.contains('hidden')){
                  EleDes.classList.add('hidden');
                }
                if(EleDesAttr === OptionAttr){
                  EleDes.classList.remove('hidden');
                }
              })
            }
          }
        });
      }
    }
  }
  ServiceDropdown();
  
});

// Our Experts read more / read less functionality
document.addEventListener('DOMContentLoaded',()=>{
  const ReadMoreButtons = document.querySelectorAll('.mosaic__item .read-more-btn');
  if(ReadMoreButtons.length > 0){
    ReadMoreButtons.forEach((button)=>button.addEventListener('click',ToggleMoreLess.bind(this)), true);
  }
  function ToggleMoreLess(event){
    const _this = event.currentTarget;
    const closestMainDesc = _this.closest('.mosaic_main_read_desc');
    if(closestMainDesc){
      const lessDescEle = closestMainDesc.querySelector('.less-text');
      const moreDescEle = closestMainDesc.querySelector('.more-text');
      if(moreDescEle.hasAttribute('hidden')){
        moreDescEle.removeAttribute('hidden');
        lessDescEle.setAttribute('hidden', true);
        _this.innerText = 'read less';
      } else{
        moreDescEle.setAttribute('hidden', true);
        lessDescEle.removeAttribute('hidden');
        _this.innerText = 'read more';        
      }
    }
  }
})

// Science page tabbing funcrtionality

document.addEventListener('DOMContentLoaded',()=>{
  const Multicolumn_Tabs = document.querySelectorAll('[data-tabing]');
  if(Multicolumn_Tabs.length > 0){
    Multicolumn_Tabs.forEach(tab=>{
      tab.addEventListener('click',()=>{
        const tab_attribute = tab.getAttribute('data-tabing');
        const AllSelectedTabs = document.querySelectorAll('[selected-tab]');
        if(AllSelectedTabs.length > 0){
          AllSelectedTabs.forEach(selectedTab=>{
            selectedTab.classList.remove('current');
          });
        }
        const AllSelectedTabsDesc = document.querySelectorAll('[desc-tab]');
        if(AllSelectedTabsDesc.length > 0){
          AllSelectedTabsDesc.forEach(selectedTabDesc=>{
            console.log(selectedTabDesc);
            selectedTabDesc.setAttribute('hidden', true);
          });
        }
        document.querySelector(`[selected-tab=${tab_attribute}]`).classList.add('current');
        document.querySelector(`[desc-tab=${tab_attribute}]`).removeAttribute('hidden');
      })
    })
  }
})

// Jump reviews to review section on PDP 

window.onload = function() {
  setTimeout(function() {
    var linkElement = null;
    var reviewWidget = document.getElementById('shopify-block-AMG9EeFpOTm1JTzJkK__loox_reviews_loox_trust_badge_UNwGre');
    var clickTriggered = false;
    if (reviewWidget) {
      reviewWidget.addEventListener('click', function () {
          if (clickTriggered) {
              return;
          }
          clickTriggered = true;
          if (!linkElement) {
              linkElement = document.createElement('a');
              var targetElement = document.getElementById('App--template--24496743612801__17274447547827a930');
  
              if (targetElement) {
                  linkElement.href = '#' + targetElement.id;
                  this.appendChild(linkElement);
                  linkElement.style.display = 'none';
              } else {
                  console.error('Target element not found!');
              }
          }
          if (linkElement) {
              linkElement.dispatchEvent(new MouseEvent('click', {
                  'bubbles': true,
                  'cancelable': true,
              }));
  
              setTimeout(function() {
                  clickTriggered = false;
              }, 100);
          }
      });
    }
  });
}

